export default __webpack_public_path__ + "83fe37f5a951d425ce793c19db40d015.jpg";